import React , { useEffect , useState } from 'react';
import styles from './Textarea.module.scss';

export default function Textarea({ onChange , name , label , defaultValue , value , withErrors , error , register , placehloder , type , ...rest }) {
  
  const [ textValue , setTextValue ] = useState(defaultValue);

  useEffect(() => {
    setTextValue(value);
  }, [value]);

  function handleChange(val) {
    if (onChange) {
      onChange(val);
    }
    setTextValue(val)
  }
  
  return (
    <div className={styles.textarea}>
      <label htmlFor={name}>{label}</label>
      {!register ? 
        <>
          <textarea
            name={name}
            placeholder={placehloder}
            value={textValue ? textValue : ''}
            onChange={(e) => handleChange(e.target.value)}
            />
        </>
        :
        <>
          <textarea
            name={name}
            className={error ? styles.error : ''}
            placeholder={placehloder}
            defaultValue={defaultValue ? defaultValue : ''}
            ref={register}
            {...rest}
            />
        </>
      }
      {withErrors && <p className={styles['error-message']}>{error && error}</p>}
    </div>
  )
}
